import { render, staticRenderFns } from "./AddAttributes.vue?vue&type=template&id=95932e8e&"
import script from "./AddAttributes.vue?vue&type=script&lang=js&"
export * from "./AddAttributes.vue?vue&type=script&lang=js&"
import style0 from "./AddAttributes.vue?vue&type=style&index=0&id=95932e8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports